"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoPoint = void 0;
const ngeohash_1 = __importDefault(require("ngeohash"));
class GeoPoint {
    constructor(latitude, longitude) {
        this.serialize = () => ({
            latitude: this.latitude,
            longitude: this.longitude,
            geohash: this.geohash,
        });
        if (latitude < -90 || latitude > 90) {
            throw new Error('Latitude must be between -90 and 90');
        }
        if (longitude < -180 || longitude > 180) {
            throw new Error('Longitude must be between -180 and 180');
        }
        this.latitude = latitude;
        this.longitude = longitude;
        this.geohash = ngeohash_1.default.encode(latitude, longitude);
    }
}
exports.GeoPoint = GeoPoint;
//# sourceMappingURL=geo-point.js.map